import React, { useState, useEffect, useRef } from "react";
import ImmediateSessionDot from "../ImmediateSessionDot";
// import moment from "moment";
import { filterList } from "../data";
import { useDispatch, useSelector } from "react-redux";
import Search from "../../../../components/search";
import { useNavigate, useSearchParams } from "react-router-dom";
import Sorting from "../../../../components/sorting";
import Pagination from "../../../../components/tablePagination";
import Select from "react-select";
import { fireFilter } from "../functions";
import CsvDownload from "../../../../components/csvdownload";
import ConfirmCancel from "../subcomponents/cancelpopup";
import { emptyAllSelectBox, session_id_beg, session_id_end } from "../../../../utils/helpers";
import AppointmentInfoPanel from "../AppointmentInfoPanel";
import { resendSurveyEmail } from "../../../../services/medium";
import { toast } from "react-toastify";
import Button from "../../../../components/button";
import { noshowGroupAppointments, noshowRemoveGroupAppointments, sendRequestAdmin, settlePaymentOutside, ExportData } from "../../../../services/admin";
import { setLoading } from "../../../../reducer/auth/auth";
import Filter from "../../../../components/filter";
import NoshowBox from "../subcomponents/noshowbox";
import WorkerBox from "../subcomponents/workersbox";
import UpdateAppointments from "../../Subcomponents/updateappt";
import UpdateVideo from "../../Subcomponents/updatevideo";
import SettlePaymentOutsitePopup from "../subcomponents/settleoutsidepopup";
import CopyComponent from "../../../../components/copyComponent";
import RefundDeleteModal from "../../../../components/refundConfirmModal";
import {
  
  setCompletedAppointmentsPage,
  setCompletedAppointmentsrowsPerPage,
 
} from "../../../../reducer/adminSlice";
import {  setLoadingContent, setLoadingText } from "../../../../reducer/auth/auth";
import {  filterVisibleTimeZones } from "../../../../utils/helpers";
import { refundingAppointment, stopPaymentAppointment } from "../../../../services/medium";

import { isRefundStatus } from "../../../../utils/utils";
var apptAvatarPalettes = [
  { background: '#f5e6d8', color: '#b87040' },
  { background: '#faf0e8', color: '#c07838' },
  { background: '#eeddd0', color: '#a86030' },
  { background: '#f7ece0', color: '#d5a67b' },
  { background: '#f0e0cc', color: '#b87848' },
];
function apptGetInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function apptGetAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % apptAvatarPalettes.length : 0;
  return Object.assign({}, apptAvatarPalettes[idx], {
    width: 36, height: 36, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', fontSize: '13px', flexShrink: 0,
  });
}


const headers = [
  { label: "Medium Name", key: "medium_name" },
  { label: "Client Name", key: "client_name" },
  { label: "Date", key: "date" },
  // { label: "Time", key: "time" },
  { label: "Session Name", key: "session_type" },
  { label: "Medium Email", key: "medium_emails" },
  { label: "Client Email", key: "client_emails" },
  // { label: "Meeting Link", key: "meeting_link" },
  { label: "Feedback Links", key: "" },
  // { label: 'Date and Time Cancelled', key: 'date_time_canceled' },
  // { label: "Cancelled By", key: 'userby' },
  // { label: "No Show By", key: 'userby' },
];

export default function Completed(props) {
  const {
    onTransferCount,
    completedAppointments,
    changeHandler,
    filterListAppointments,
    filterReset,
    getPaginationData,
    setFilterValues,
    setSearchValues,
    getAllAppointmentsList,
    activeTab,
    completedAppointmentsPage,
    completedAppointmentsrowsPerPage,
    searchValue,
    filterValues,
    serviceTypeList,
    changeHandlerFilter,
    serviceFilterValue,
    setSortingNameOrderBy,
    setSortingTabType,
    setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,
    setFilterValueOptions,
    filterValueOptions,
    setServiceTypeShow,
    serviceTypeShow,
    exportDownload,
    setCompletedAppointments,
    searchValueFilter,
    setAllCompletedCount,
    actionData,
    isSearching
  } = props;

  // const copyMeetingLink = (url) => {
  //   navigator.clipboard.writeText(url);
  // };
  const { allCompletedCount } = useSelector((state) => state.users);
  const navigate = useNavigate();
  const [active, setActive] = useState({});
  const [attendeesList, setattendeesList] = useState([])
  const [updateItem, setUpdateItem] = useState({});
  const [noshowFrom, setNoShowFrom] = useState('');
  const [noShowActive ,setNoShowActive] = useState();

  const [settlePaymentLocalId, setsettlePaymentLocalId] = useState('')
  const [searchParams] = useSearchParams();
   const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');
  const dispatch = useDispatch()
  const [filters, setFilters] = useState({ filterValues: { screen_name: ""}, operator: "" });
  const filtersRef = useRef({ filterValues: {}, operator: "" });
  const [isFilterDirty, setIsFilterDirty] = useState(true);
  const [isRefund, setIsRefund] = useState(0);
  // See the matching comment in admin/appointments/upcoming/index.js —
  // tracks whether the in-flight refund/waive confirm targets a specific
  // group attendee so a full refetch (actionData) can run on success,
  // since the NoshowBox modal renders its own attendeesList snapshot that
  // the local patch doesn't reach.
  const [isAttendeeAction, setIsAttendeeAction] = useState(false);
  const [selectedMedium, setSelectedMedium] = useState();
  const [backFillId, setBackFillId] = useState('');
  const [panelAppointment, setPanelAppointment] = useState(null);
  const [panelViewType, setPanelViewType] = useState('appointment');
  useEffect(() => {
      // if (page !== null) {
  
      //   dispatch(setCompletedAppointmentsPage(page));
      // }
      // if (rowperpage !== null) {
      //   dispatch(setCompletedAppointmentsrowsPerPage(rowperpage));
      // }
      if (filterOprater && Object.keys(searchValue).length > 0) {
      const newValues = {
        filterValues: { ...searchValue },
        operator: filterOprater
      };

    console.log("NEW VALUES:", newValues);
      filtersRef.current = newValues; 
    }
  
    }, [])

  const changeHandlerLocal = (e, type, id) => {
    let value = e.target.value;
    console.log('id', e)
    if (value === '') {
      setActive({ e: e, type: 6, id: id });
    } else {
      setActive({ e: e, type: 2, id: id });
    }
    window.loadModal2("#ConfirmCancelAdminCompleted", "show");
  };

  const cancelRequest = () => {
    // data-dismiss="modal" on the Cancel button handles hiding the modal;
    // calling loadModal2 here as well causes double-hide and stacks backdrops.
    emptyAllSelectBox();
  };
  const confirmRequest = () => {
    let { e, type, id } = active;
    changeHandler(e, type, id);
  };
  const resendSurveyLink = (id) => {
    let body = {
      appointment_id: id
      // survey_link
    };
    resendSurveyEmail(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Email Sent Succesfully", {
            position: "top-center",
          });
          // getLink();
        }
        else {
          toast.error("Something went wrong", {
            position: "top-center",
          });
        }
      })
      .catch(() => { });
  }
  const sendRequet = (id) => {
    let body = {
      appointment_id: id
    }
    sendRequestAdmin(body).then((data) => {
      if (data.data.status) {
        toast.success(data.data.message, {
          position: "top-center",
        });
      }
      else {
        toast.error(data.data.message, {
          position: "top-center",
        });
      }

    }).catch(() => { });



  }
  const settlePaymentLocal = (id) => {

    window.loadModal2("#SettlePaymentOutsitePopup", "show");
    setsettlePaymentLocalId(id)
  }
  const settleoutsidepopupconfirmRequest = () => {
    settlePayment(settlePaymentLocalId);
  }

  const settleoutsidepopupcancelRequest = () => {
    // data-dismiss="modal" on the Cancel button handles hiding the modal
  }
  const settlePayment = (id) => {
    dispatch(setLoading(true))
    settlePaymentOutside(id).then((data) => {
      dispatch(setLoading(false))
      if (data.data.status) {

        toast.success("Appointment Updated Successfully!!", {
          position: "top-center",
        });
        const info = {
          page: completedAppointmentsPage,
          rowsPerPage: completedAppointmentsrowsPerPage,
        };
        getAllAppointmentsList(info, activeTab)
      }
      else {
        toast.error(data.data.message, {
          position: "top-center",
        });
      }
    })
  }

  const openNoShowBox = (list, from,item) => {
    setNoShowActive(item);
    setNoShowFrom(from);
    setattendeesList(list)
    window.loadModal('#NoshowBox', 'show');
  }
   const openWorkerBox = (list, from, item) => {
    setNoShowActive(item)
    setNoShowFrom(from);
    setattendeesList(list)
    window.loadModal('#WorkerBox', 'show');
  }
  

  const noshowGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: item.id,
      user_id: item.user_id
    }
    noshowGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 25,
        };
        //getAppointmentsNewListData("No Shows",item.id);
      // getAllAppointmentsList(data, activeTab,);
       actionData(activeTab);
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })
  }
  const noshowRemoveGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: noShowActive.id,
      user_id: item.user_id
    }
    noshowRemoveGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 25,
        };
        getAllAppointmentsList(data, activeTab,);
      }
      else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    })
  }
  const openUpdateappointmentBox = (item) => {
    setUpdateItem(item)
    window.loadModal2('#UpdateAppointments', 'show')
  }
  const speakerEventVideo = (item) => {
    setUpdateItem(item)
    window.loadModal2('#UpdateVideo', 'show')
  }

  const getAppointmentsNewList = () => {

    const info = {
      page: completedAppointmentsPage,
      rowsPerPage: completedAppointmentsrowsPerPage,
    };
    getAllAppointmentsList(info, activeTab)
    window.loadModal2('#UpdateAppointments', 'hide')
  }
  let info = JSON.parse(localStorage.getItem('paginationAppointment'))
  const navigateEdit = (e, id) => {
    window.renderFirst = false
    if (e.target.className == "capitalizeMedium") {
      navigate(`/profile-edit/${id.medium_id}?&searchURL=appointments&view=1&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
    }
    if (e.target.className == "capitalize") {
      if (id.client_user_type == 3) {
        navigate(`/edit/${id.client_id}?&searchURL=appointments&view=1&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      } else {
        navigate(`/profile-edit/${id.client_id}?&searchURL=appointments&view=1&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info !== null ? info.page : 1}&rowperpage=${info !== null ? info.rowsPerPage : 25}&serviceFilterValue=${encodeURIComponent(JSON.stringify(serviceFilterValue))}&searchFilterOprater=${filterOprater}`);
      }
    }
  };
  const checkAppId = (appoinment) => {
    if (appoinment.is_group_session === 0) {
      return appoinment.id
    }
    else if (appoinment.is_group_session === 1) {
      if (appoinment.attendees == undefined) {
        if (appoinment.parent_id == null) {
          return appoinment.id
        }
        else {
          return appoinment.parent_id
        }

      }
      else {
        return appoinment.id
      }

    }
    else {
      return appoinment.id
    }

  }

  const handleSessionClick = (e, appoinment, columnType = 'appointment') => {
    if (e.target.closest && e.target.closest('button, a, input, select, textarea, [role="button"], .toggle-button-cover')) {
      return;
    }
    e.stopPropagation();
    if (columnType === 'medium' && !appoinment.medium_details) {
      columnType = 'appointment';
    }
    if (columnType === 'client' && !appoinment.client_details) {
      columnType = 'appointment';
    }
    setPanelViewType(columnType);
    setPanelAppointment(Object.assign({}, appoinment, {
      sessionIdDisplay: session_id_beg + checkAppId(appoinment) + session_id_end,
    }));
  };

  const createString =() => {

    let string = `screen_name=${
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : ""}&session_type=${searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : ""}&session_id=${searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : ""}&name=${
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : ""}&medium_email=${
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : ""}&client_email=${
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : ""}&meeting_id=${
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          :""}&created_at=${searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : ''}&oprater=${filterOprater !== undefined ? filterOprater : ""}&country=${searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""}
      `
      return string;
  }

const handleVideoLinkChange = (id, newVideoLink) => {
  setCompletedAppointments(prevAppointments =>
    prevAppointments.map(item =>
      item.id === id
        ? { ...item, video_link: newVideoLink }
        : item
    )
  );
};
const exportData =()=>{
     let info = {
            appoitment_type: "completed", appoitment_value: 1,queryString: createString()
        }
    ExportData(info).then((data) => {
            if (data.data.status) {
                toast.success(data.data.message, { position: "top-center" });
            }
            }).catch(() => { })
  }

  const exportAllData = () => {
    let info = {
      appoitment_type: "completed", 
      appoitment_value: 1,
      queryString: "" 
    }
    ExportData(info).then((data) => {
      if (data.data.status) {
        toast.success("All data exported successfully", { position: "top-center" });
      }
    }).catch(() => { })
  }


  const getAppointmentsNewListData = (toName, id ) => {
    console.log(`Updated: moved one from to ${toName}`);
    window.loadModal2('#UpdateAppointments', 'hide')
    setCompletedAppointments((prev) => prev.filter((item) => item.id !== id));
    dispatch(
            setAllCompletedCount(
              allCompletedCount - 1
              )
          )
    onTransferCount( "Completed", toName);
    
  
    // you can call API or refresh appointment list here
  };
  
  const fliterdata = (name, oprater) => {
  const newValues = {
    filterValues: { ...name },
    operator: oprater
  };
console.log("NEW VALUES:", newValues);
  filtersRef.current = newValues; // <--- instant update (no delay)
  setFilters(newValues);
  setIsFilterDirty(false);          // UI update (async, but that's fine)
};


const LoadData = () => {
  // optional: clear old UI result before new search
  console.log("FILTERS USED:", filtersRef.current.filterValues, filtersRef.current.operator);


// setUpcomingAppointments([]);
  filterListAppointments(
    filtersRef.current.filterValues,
    filtersRef.current.operator
  );
  setIsFilterDirty(true);
};
const handleNoShow = (e, appoinment) => {
  let value = e.target.value;
  setBackFillId(appoinment.id)
    setSelectedMedium(appoinment.medium_id)
    let noShowBy = value;
    if(value == "settle_outside"){
      settlePaymentLocal(appoinment.id);
      return;
    }
     if(value == "Send_Request"){
      sendRequet(appoinment.id);
      return;
    }
    if(value === "refund"){
      setIsRefund(1);
      setIsAttendeeAction(false);
      // if(appoinment.survey_status_type == 0){
        window.loadModal2("#ConfirmRefundAppointment", "show");
        return;
      // }else{
      //     refundingCall(appoinment.medium_id, appoinment.id);
      //     return;
      // }
    }
     if(value === "stop_payment_request"){
       setIsRefund(0);
       setIsAttendeeAction(false);
      //  if(appoinment.survey_status_type == 0){
        window.loadModal2("#ConfirmRefundAppointment", "show");
        return;
      //  } else{
      // stopPaymentCall(appoinment.medium_id, appoinment.id);
      // return;
      //  }
    }
}
 // Group sessions nest one row per attendee under appointment.attendees[],
 // each with its own transaction/payment_status; a refund/waive can target
 // either a top-level (1:1) row or one specific attendee's row, so this
 // patches whichever one matches appointmentId instead of assuming it's
 // always the top-level row.
 //
 // The host (whoever originally booked, parent_id null) appears TWICE in
 // the payload: once as the top-level row, and again as the last entry
 // inside its own attendees[] (see AppointmentRepository::
 // getAdminAllAppointments — `$res[$key]['attendees'][] = $val`). Refunding
 // the host matches appointment.id, but NoshowBox only ever reads
 // attendees[], so both copies must be patched — returning early after the
 // top-level match left the attendees[] copy stale, which is why the popup
 // kept showing "Paid" for the host attendee until reload.
 const patchPaymentStatus = (list, appointmentId, newStatus, extra = {}) =>
   list.map((appointment) => {
     let updated = appointment;

     if (appointment.id === appointmentId) {
       updated = { ...updated, payment_status: newStatus, ...extra };
     }

     if (Array.isArray(appointment.attendees)) {
       const attendeeIndex = appointment.attendees.findIndex(
         (attendee) => attendee.id === appointmentId
       );
       if (attendeeIndex !== -1) {
         const updatedAttendees = [...appointment.attendees];
         updatedAttendees[attendeeIndex] = {
           ...updatedAttendees[attendeeIndex],
           payment_status: newStatus,
           ...extra,
         };
         updated = { ...updated, attendees: updatedAttendees };
       }
     }

     return updated;
   });

 const refundingCall = (mediumId, appointmentId, isSurveyPending=false) => {
    let body = {
      medium_id: mediumId,
      appointment_id: appointmentId,
      is_survey_pending: isSurveyPending ? 1 : 0
    }
   
      refundingAppointment(body)
      .then((data) => {
        emptyAllSelectBox()
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(''));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))
          setCompletedAppointments(prev =>
            patchPaymentStatus(prev, appointmentId, "Refund Processing")
          );

          // The patch above only updates the master list; the already-open
          // NoshowBox modal renders a separate `attendeesList` snapshot
          // taken when it opened, which that patch never touches — patch it
          // directly too, or the modal keeps showing "Paid" until the page
          // is reloaded.
          if (isAttendeeAction) {
            setIsAttendeeAction(false);
            setattendeesList(prev =>
              prev.map(attendee =>
                attendee.id === appointmentId
                  ? { ...attendee, payment_status: "Refund Processing" }
                  : attendee
              )
            );
          }

          setTimeout(() => {
          
              //no show
              toast.success("Status Updated Successfully", {
                position: "top-center",
              });
            
            
          }, 1000);

        
        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(''));
      });
  }

  const stopPaymentCall = (mediumId, appointmentId, isSurveyPending=false) => {
    let body = {
      medium_id: mediumId,
      appointment_id: appointmentId,
      is_survey_pending: isSurveyPending ? 1 : 0
    }
   
      stopPaymentAppointment(body)
      .then((data) => {
        emptyAllSelectBox()
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(''));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

if(isSurveyPending){
setCompletedAppointments(prev =>
          patchPaymentStatus(prev, appointmentId, "Waived", { survey_status_type: 1, survey_link: null })
        );
}else{
setCompletedAppointments(prev =>
          patchPaymentStatus(prev, appointmentId, "Waived")
        );
      }

          setTimeout(() => {
          
              //no show
              toast.success("Status Updated Successfully", {
                position: "top-center",
              });
            
            
          }, 1000);

          
        }
        else {

      // ✅ THIS will show "Transaction not found"
      toast.error(data.data.message || "Something went wrong", {
        position: "top-center",
      });

    }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(''));
  
      });
  }
   const confirmAppt = () => {
      if(isRefund){
        refundingCall(selectedMedium, backFillId,false);
      } else {
        stopPaymentCall(selectedMedium, backFillId,false);
      }
    }
     const confirmApptNo = () => {
      // goToMediumBackFill(backFillId, appType);
      // cancelRequest();
      if(isRefund){
        refundingCall(selectedMedium, backFillId,  true);
      } else {
        stopPaymentCall(selectedMedium, backFillId, true);
      }
    }
    // Refund for one attendee inside a group session's attendee list
    // (NoshowBox). No waive here: group sessions are pay-to-book, so
    // there's no outstanding/unpaid attendee state to waive.
    const refundAttendee = (item) => {
      setBackFillId(item.id);
      setSelectedMedium(item.medium_id);
      setIsRefund(1);
      setIsAttendeeAction(true);
      window.loadModal2("#ConfirmRefundAppointment", "show");
    };
  return (
    <>
      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th className="min-width-100">Session #</th>
              <th>
                {/* <input type="checkbox" id="one" />
                <label htmlFor="one"></label> */}
                Medium Name
              </th>
              <th>Attendees</th>
              <th>
                <div className="d-flex align-items-center">
                  <span>Date &amp; Time</span>
                  <Sorting tab={2} callApi={filterListAppointments} view={'admin'} types={'date'} setSortingNameOrderBy={setSortingNameOrderBy} setSortingTabType={setSortingTabType} />
                </div>
              </th>
              <th>Session Name</th>
              <th>Feedback<br />Status</th>
              <th>Feedback<br />Links</th>
              <th>Payment<br />Status</th>
              <th>Payment<br />Request</th>
              {/* <th>Emails</th> */}
              {/* <th>Meeting Link</th> */}
              <th>Video<br />Upload</th>
              <th>No Show /<br />Give Add'l</th>
              
              <th>Status</th>
              <th><div className="d-inline-flex align-items-center align-items-center">
                <span> Created at</span>{" "}
                <Sorting tab={2} callApi={filterListAppointments} view={'admin'} types={'created_at'} setSortingNameOrderBy={setSortingNameOrderBy}
                  setSortingTabType={setSortingTabType} />
              </div>
              </th>
              {/* <th>Contact</th> */}
              {/* <th>Action</th> */}
            </tr>
               {isSearching ? (
               <tr>
    <td colSpan="12" className="text-center py-4">
      <div className="custom-loader">
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
      </div>
      <div className="loader-text mt-2">Loading appointments...</div>
    </td>
  </tr>
                ) :
            completedAppointments.length > 0 ? (
              completedAppointments.map((appoinment) => (
                <tr onClick={(e) => handleSessionClick(e, appoinment)} className={`innr ${appoinment.is_worker_appointment == 1 ? "isWorkedBG" : "" }`} style={{ cursor: 'pointer' }}>
                  {/* <td>{session_id_beg + checkAppId(appoinment) + session_id_end}{appoinment.give_add1_highlight ? <img className="ml-1 star-app-hightlight" src="../images/star.png" /> : ''}</td> */}
                  <td className="pointer" onClick={(e) => handleSessionClick(e, appoinment)}>
                    <div className="d-flex align-items-center">
                      <ImmediateSessionDot appointment={appoinment} /><div className="mr-1 mt-1">
                        <CopyComponent value={session_id_beg + checkAppId(appoinment) + session_id_end} /></div>
                      <div className="mt-1">{session_id_beg + checkAppId(appoinment) + session_id_end}</div>
                      {appoinment.give_add1_highlight ? <img className="ml-1 star-app-hightlight" src="../images/star.png" /> : ''}
                      <div className="mr-1 mt-1 ml-1">
                        {appoinment.backfill_code !== null ? <>
                          ({appoinment.backfill_code})
                        </> : <></>
                        }
                      </div>
                    </div>
                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }}>
                    {/* <input type="checkbox" id="two" />
                    <label htmlFor="two"></label> */}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {appoinment.medium_profile_image ? (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                            <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.medium_profile_image} alt="" />
                          </div>
                        ) : (
                          <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalizeMedium' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.medium_name)}>{apptGetInitials(appoinment.medium_name)}</div>
                        )}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span className="capitalizeMedium" style={{ display: 'block' }}>{appoinment.medium_name} {appoinment.medium_comment === true && (<b style={{ fontSize: '22px' }}>*</b>)}</span>
                          <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {appoinment.medium_email} <CopyComponent value={appoinment.medium_email} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }}>
                    <div>
                      {appoinment.is_group_session !== 1 ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {appoinment.client_profile_image ? (
                            <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                              <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.client_profile_image} alt="" />
                            </div>
                          ) : (
                            <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.client_name)}>{apptGetInitials(appoinment.client_name)}</div>
                          )}
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="capitalize" style={{ display: 'block' }}>
                              {appoinment.client_name}
                              {appoinment.client_comment === true && (
                                <b style={{ fontSize: "22px" }}>*</b>
                              )}
                            </span>
                            <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                              {appoinment.client_email} <CopyComponent value={appoinment.client_email} />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          {appoinment &&
 Array.isArray(appoinment.attendees) &&
 appoinment.attendees.length > 0 && (
                            <span
                              className="text-underline pointer p-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                openNoShowBox(appoinment.attendees, "", appoinment);
                              }}
                            >
                              {appoinment.noOfAttendees.length}&nbsp;Attendee(s)
                            </span>
                          )}

                          {appoinment && Array.isArray(appoinment.attendees) && appoinment.attendees.length > 0 &&
                          Array.isArray(appoinment.workers) && appoinment.workers.length > 0 && <br />}

                          {appoinment && Array.isArray(appoinment.workers) && appoinment.workers.length > 0 && (
                            <span
                              className="text-underline pointer p-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                openWorkerBox(appoinment.workers, "", appoinment);
                              }}
                            >
                              {appoinment.noOfWorkers.length}&nbsp;Worker(s)
                            </span>
                          )}

                          {!((appoinment.attendees && appoinment.attendees.length > 0) ||
                            (appoinment.workers && appoinment.workers.length > 0)) && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              {appoinment.client_profile_image ? (
                                <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                                  <img width="100%" height="100%" style={{ objectFit: 'cover', display: 'block' }} src={process.env.REACT_APP_IMAGE_URL + appoinment.client_profile_image} alt="" />
                                </div>
                              ) : (
                                <div className="pointer" onClick={(e) => { e.stopPropagation(); navigateEdit({ target: { className: 'capitalize' } }, appoinment); }} style={apptGetAvatarStyle(appoinment.client_name)}>{apptGetInitials(appoinment.client_name)}</div>
                              )}
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span className="capitalize">
                                  {appoinment.client_name}
                                  {appoinment.client_comment === true && (
                                    <b style={{ fontSize: "22px" }}>*</b>
                                  )}
                                </span>
                                <div style={{ color: '#666', fontSize: '13px', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  {appoinment.client_email} <CopyComponent value={appoinment.client_email} />
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
                  <td className="width-190px ">{appoinment.guest_booking == 1 ? (<b style={{
                          fontSize: '22px',
                        }}>*</b>) : ""}{appoinment.session_name}</td>
                  <td>
                    {
                      appoinment.survey_link == null && appoinment.survey_status_type == 1 && (appoinment.survey_link == null &&  (appoinment.session_type == "7" || appoinment.session_type == "8" || appoinment.is_extra_services == 1)) ? (
                        <div className="color-d5a67b justify-content-center d-flex align-items-center height-45">
                          Exempt
                        </div>
                      ) : (appoinment.is_group_session !== 1 || appoinment.subsession_table_id == 99) &&
                        appoinment.subsession_table_id != 102 && appoinment.session_type != 34 ? (
                        <div className="color-d5a67b justify-content-center d-flex align-items-center height-45 capitalize">
                          {appoinment.survey_status}
                        </div>
                      ) : (
                        "N/A"
                      )
                    }
                  </td>
                  <td>
                    {appoinment.is_group_session !== 1 && appoinment.subsession_table_id != 102 && appoinment.session_type != 34   ?

                      <>
                        {appoinment.survey_link == null && appoinment.survey_status_type == 1 
                        && (appoinment.session_type == "7" || appoinment.session_type == "8" ||  appoinment.is_extra_services == 1) ?
                        'N/A'
                        : appoinment.survey_status !== "pending" && appoinment.survey_status !== "partner pending" ? (
                          <div className="color-d5a67b d-flex align-items-center height-45 capitalize"> {appoinment.survey_status}</div>
                        ) : (
                          <Button
                            status={0}
                            onClick={(e) => resendSurveyLink(appoinment.id)}
                            type="button"
                            className={`resend-btn w-130`}
                            title="Send Email"
                          />
                        )}
                      </>
                      :
                      'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.attendees == undefined && appoinment.subsession_table_id != 102 ?

                      <div className="color-d5a67b d-flex align-items-center height-45">
                        {appoinment.payment_status}
                      </div>
                      :
                      'N/A'
                    }
                  </td>
                  <td >
{appoinment.subsession_table_id != 102 ? (
  <>
   <>
                        {appoinment.is_group_session === 0  && (appoinment.session_type === "8" || appoinment.session_type === "7" || appoinment.is_extra_services == 1 || appoinment.payment_request_button === "Send Request") ?
                          <select
                            // value={appoinment.statusValue}
                            onChange={(e) => handleNoShow(e, appoinment)}
                            className="appointment-select-box"
                          >
                            <option value="" selected disabled>
                              Select
                            </option>

                        {appoinment.payment_request_button === "Send Request" &&
                          appoinment.session_type === "7" && (
                            <option value={"settle_outside"}>{"Settle Outside"}</option>
                          )}
                            {appoinment.payment_request_button === "Send Request" 
                         && (
                            <option value={"Send_Request"}>{"Send Request"}</option>
                          )}
                            {((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && !isRefundStatus(appoinment.payment_status)) && (
                              <>
                              
                              <option value={"refund"}>{"Refunding"}</option>
                              </>
                            )}
                            {(appoinment.session_type === "7" && !isRefundStatus(appoinment.payment_status) && appoinment.payment_status != "Waived" )&& (
                              <option
                                value={
                                  appoinment.payment_status === "Paid"
                                    ? "refund"
                                    : "stop_payment_request"
                                }
                              >
                                {appoinment.payment_status === "Paid"
                                  ? "Refunding"
                                  : "Stop Payment Request"}
                              </option>
                            )}


                            
                           
                          </select>
                          :
                          'N/A'
                        }
                      </>
                    {/* {appoinment.payment_request_button === "Send Request" ? <Button
                      status={0}
                      onClick={(e) => sendRequet(appoinment.id)}
                      type="button"
                      className={`resend-btn height-35 w-140`}
                      title="Send Request"
                    /> : <div className="color-d5a67b text-center">{appoinment.payment_request_button}</div>
                    }
                    {appoinment.payment_request_button === "Send Request" && appoinment.session_type === "7" && <Button
                      status={0}
                      onClick={(e) => settlePaymentLocal(appoinment.id)}
                      type="button"
                      className={`resend-btn height-35 w-140 mt-2`}
                      title="Settle Outside"
                    />
                    } */}
                    </>
                    ): "N/A"}
                  </td>
{/* Emails column hidden */}
                  {/* <td>
                    <div>
                      <p className="d-flex">
                        <div> Client:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.client_email}{" "}
                        </div>
                      </p>
                      <p className="d-flex">
                        {" "}
                        <div>Medium:</div>{" "}
                        <div className="d5a67b ml-1">
                          {appoinment.medium_email}
                        </div>
                      </p>
                    </div>
                  </td> */}
                  {/* <td>Practice - 60 Min (30 Min each)</td> */}
                  {/* <td className="googl-link">
                    <a
                      className="appointment-links"
                      href={appoinment.meeting_link}
                      target="_blank"
                    >
                      {appoinment.meeting_link}
                    </a>
                    <img
                      onClick={() => copyMeetingLink(appoinment.meeting_link)}
                      className="googl-link-copy-img "
                      alt="copy"
                      src="images/copy.png"
                    />
                  </td> */}
                  <td>
                    {appoinment.subsession_table_id ==95 ?
                     <>
                        <Button
                          status={0}
                          onClick={() => speakerEventVideo(appoinment)}
                          type="button"
                          className={`resend-btn w-130`}
                          title={`${appoinment.video_link ? "Edit Video" : "Upload Video"}`}
                        />
                      </>:
                     "-"}
                    </td>
                  <td>
                    {appoinment.is_group_session !== 1 ?
                      <select
                        //  value={appoinment.statusValue}
                        onChange={(e) =>
                          changeHandlerLocal(e, 2, appoinment.appointmentId)
                          // changeHandler(e, 2, appoinment.appointmentId)
                        }
                        className="appointment-select-box"
                      >
                        <option value="" selected disabled>
                          Select
                        </option>
                        {Object.entries(appoinment.userArray).map((show) => (
                          <option value={show[0]}>{'NS-' + show[1]}</option>
                        ))}
                        {appoinment.session_type === "5" ? <option value={""}>{"Give Add’l"}</option> : ''}
                      </select>
                      :
                      <>
                        <Button
                          status={0}
                          onClick={() => openNoShowBox(appoinment.attendees,'',appoinment)}
                          type="button"
                          className={`resend-btn w-130`}
                          title="No Show"
                        />
                      </>
                    }
                  </td>
                  <td>

                    <Button
                      status={0}
                      onClick={(e) => openUpdateappointmentBox(appoinment)}
                      type="button"
                      className={`resend-btn w-130`}
                      title="Change Status"
                    />

                  </td>
                  <td>
                    {appoinment.createdDate ? (
                      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.5' }}>
                        <span>{appoinment.createdDate.split(',')[0]}</span>
                        <span style={{ color: '#888', fontSize: '12px' }}>{(appoinment.createdDate.split(',')[1] || '').trim()}</span>
                      </div>
                    ) : ''}
                  </td>
                  {/* <td className="change">
                    <a href="#">
                      <img src="../images/email-blu.png" />
                      Email
                    </a>
                  </td> */}
                  {/* <td className="dot-image">
                    <img src="../images/Unionblck.png" />
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}

          </tbody>
        </table>
        </div>
        <Pagination
          rowsPerPageOptions={[25, 50, 100]}
          count={allCompletedCount}
          activeTab={"completedAdmin"}
          getPaginationData={getPaginationData}
          completedAppointmentsPage={completedAppointmentsPage}
          completedAppointmentsrowsPerPage={completedAppointmentsrowsPerPage}
        />
        <ConfirmCancel
          deleteUser={confirmRequest}
          cancelRequest={cancelRequest}
          id={'ConfirmCancelAdminCompleted'} />
        <SettlePaymentOutsitePopup
          deleteUser={settleoutsidepopupconfirmRequest}
          cancelRequest={settleoutsidepopupcancelRequest}
          id="SettlePaymentOutsitePopup"
        />
        <NoshowBox
          noShowActive={noShowActive}
          list={attendeesList}
          noShowRequest={noshowGroupAppointment}
          noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
          noshowFrom={noshowFrom}
          refundAttendee={refundAttendee}
        />

          <WorkerBox
          noShowActive={noShowActive}
          list={attendeesList}
          noShowRequest={noshowGroupAppointment}
          noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
          noshowFrom={noshowFrom}
        />
          <RefundDeleteModal
            deleteUser={confirmAppt}
            cancelRequest={confirmApptNo}
            id={"ConfirmRefundAppointment"}
            label={"Should client still receive feedback survey?"}
            btnLabel={"Continue"}
          />
        <UpdateAppointments
          updateItem={updateItem}
          appType={['Cancel', 'No Show', 'Restrict', 'Ended Early']}
          getAppointmentsNewList={getAppointmentsNewListData}
        />
        <UpdateVideo
          updateItem={updateItem}
          setUpdateItem={setUpdateItem}
          getAppointmentsNewList={getAppointmentsNewList}
            handleVideoLinkChange={handleVideoLinkChange}
        />
        <AppointmentInfoPanel
          appointment={panelAppointment}
          viewType={panelViewType}
          onClose={() => setPanelAppointment(null)}
          clientLabel="Attendee"
          onMediumClick={(appt) => navigateEdit({ target: { className: 'capitalizeMedium' } }, appt)}
          onClientClick={(appt) => navigateEdit({ target: { className: 'capitalize' } }, appt)}
        />
      </div>
    </>
  );
}
